// extracted by mini-css-extract-plugin
export default {"header":"section-header_header__ln3XG","header__title":"section-header_header__title__+y+Q0","header__link":"section-header_header__link__YeGrH"};